import React, { useState } from "react";
import { imgs } from "../../assets/imgs";
import CustomModal from "../../components/common/CustomModal";
import { ModalInsings } from "../../components/common/ModalInsings";
import { icons } from "../../assets/icons";
import { useSelector } from "react-redux";
import { useGetInsings } from "../../hooks/useGetInsings";
// import { icons } from '../../assets/icons'

export const InsingsMenu = ({ onToggleInsings }) => {
	const [modalVisible, setModalVisible] = useState(false);
	const { activitiesInformation } = useSelector((state) => state.menu);
	const { badgets, numberCompleteBadgets } = useGetInsings(activitiesInformation);
	return (
		<div className="w-full h-full hidden-scrooll overflow-y-auto animate__animated animate__fadeInRight">
			<CustomModal isVisible={modalVisible}>
				<ModalInsings
					xp={`75`}
					insigImg={imgs.insignia}
					title={"Consigue hacer la limpieza más rapida"}
					onClose={setModalVisible}
				></ModalInsings>
			</CustomModal>
			<div className="w-full h-[60px] flex items-center gap-4 pl-4">
				<div className="h-8 w-8">
					<img className="h-full w-full object-contain" src={icons.insig} alt="insignias" />
				</div>
				<p className="font-bold text-sm text-white">Insignias</p>
				<p className="font-bold text-sm text-white">
					{numberCompleteBadgets} de {badgets.length}
				</p>
			</div>
			<div className="w-full h-[cacl(100%-120px)] overflow-hidden flex justify-center py-6 md:py-12">
				<div className="h-full w-full grid grid-cols-3 md:grid-cols-4 gap-4 px-7 overflow-hidden">
					{badgets.map((badget, index) => {
						return (
							<div key={`${index}-badgets`} className={`h-full w-full overflow-hidden}`}>
								<div
									className="h-full w-full"
									onClick={() => {
										if (badget.complete) {
											setModalVisible(true);
										}
									}}
								>
									<img
										className="h-full w-full object-contain"
										src={badget.complete ? imgs.insignia : imgs.insigniavacia}
										alt="insignia"
									/>
								</div>
							</div>
						);
					})}
				</div>
			</div>
			{/* <div className="w-full h-[60px] overflow-hidden flex justify-center px-14">
				<div
					onClick={() => onToggleInsings(false)}
					className="h-[40px] w-[224px] border-2 border-white rounded-xl flex justify-center items-center"
				>
					<p className="text-white font-semibold">Regresar</p>
				</div>
			</div> */}
		</div>
	);
};
